import { useEffect, useState } from 'react';
/**
 * Hook to check if a header element exists in the DOM
 * @returns boolean indicating if header is present
 */
export function useHasHeader() {
    const [hasHeader, setHasHeader] = useState(false);
    useEffect(() => {
        const checkForHeader = () => {
            const headerElement = document.querySelector('header');
            setHasHeader(!!headerElement);
        };
        // Check immediately
        checkForHeader();
        // Use MutationObserver to watch for DOM changes
        const observer = new MutationObserver(() => {
            checkForHeader();
        });
        // Observe changes to the document body
        observer.observe(document.body, {
            childList: true,
            subtree: true,
        });
        return () => {
            observer.disconnect();
        };
    }, []);
    return hasHeader;
}
